

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const BrandEnterEmail = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handleNextClick = async () => {
    if (!email) {
      toast.error('Please enter a valid email address');
      return;
    }

    setLoading(true);

    try {
      const response = await fetch('https://server-side-influencer.onrender.com/brand/generate-otp', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();

      if (response.status === 200) {
        toast.success('OTP sent successfully for password reset');
        navigate('/otpbrand', { state: { email } });
      } else {
        toast.error(data.message || 'Failed to send OTP');
      }
    } catch (err) {
      toast.error('Error: OTP send failed');
      navigate('/otpbrand', { state: { email } });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-white p-4">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 w-full max-w-6xl items-center">
        {/* Left Side - Email Form s*/}
        <div className="w-full flex flex-col items-center md:items-start">
          {/* Logo */}
          <img
            src="/logo-ico.png"
            alt="Logo"
            className="w-56 h-36 md:w-64 md:h-48 object-contain mb-4"
          />

          {/* Instructional Text */}
          <div className="text-center md:text-left mb-6">
            <h2 className="text-2xl md:text-3xl font-bold text-black mb-2">Forgot password?</h2>
            <p className="text-gray-700 text-base">No worries, we’ll send you OTP in your mail id for password reset</p>
          </div>

          {/* Email Input */}
          <input
            type="email"
            placeholder="Enter your email"
            value={email}
            onChange={handleEmailChange}
            className="w-full p-3 border border-gray-300 rounded-md text-lg mb-4 focus:outline-none focus:ring-2 focus:ring-blue-500"
          />

          {/* Submit Button */}
          <button
            onClick={handleNextClick}
            disabled={loading}
            className="w-full shadow-xl py-3 px-4 text-sm tracking-wide rounded-lg text-white bg-gradient-to-br from-purple-600 to-blue-500 hover:bg-gradient-to-bl focus:outline-none focus:ring-4 focus:ring-blue-300 dark:focus:ring-blue-800 transition duration-300"
          >
            {loading ? 'Sending OTP...' : 'Next'}
          </button>
        </div>

        {/* Right Side - Image */}
        <div className="flex items-center justify-center">
          <img
            src="/reset-password.png"
            alt="Reset Password"
            className="w-full h-auto max-w-md md:max-w-lg lg:max-w-xl object-contain"
          />
        </div>
      </div>

      <ToastContainer autoClose={5000} />
    </div>
  );
};

export default BrandEnterEmail;
